import { Source } from "@/components/maps/mapLibre/Source"
import { Layer } from "@/components/maps/mapLibre/Layer"

/**
 * Draws the driver's route as a blue line inside a LightMapView, matching the
 * fleet-overview style (`#4285F4`). Rendered below DOM markers, so the event
 * markers (refuel point, stations) stay on top of the line.
 */
export function FuelRouteLayer({
  coordinates,
}: {
  coordinates: [number, number][]
}) {
  if (coordinates.length < 2) return null
  const data = {
    type: "Feature" as const,
    properties: {},
    geometry: { type: "LineString" as const, coordinates },
  }
  return (
    <Source id="fuel-route" type="geojson" data={data}>
      <Layer
        id="fuel-route-line"
        type="line"
        layout={{ "line-join": "round", "line-cap": "round" }}
        paint={{
          "line-color": "#4285F4",
          "line-width": 4,
          "line-opacity": 1,
        }}
      />
    </Source>
  )
}
